window.addEventListener('load', function(event) {
    window.dataLayer = window.dataLayer || [];
    window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'submit') {
            const eventData= {formId:e.detail.formId, formTitle:e.detail.metaData.$source};
            Shopify.analytics.publish("klaviyoNewsletterSubmit", eventData);
        }
    });
});